import { Spacer, Input, Box} from "@chakra-ui/react";
import { FormHeaderProps } from "../../FormBuilderTypes";

const FormHeader = ({
  tab,
  handleChangeName,
  kyc
}: FormHeaderProps) => {
  return (
    <>
      <Box pb="5">
        <Input
          value={tab.name}
          isInvalid={!!tab.error}
          errorBorderColor="red.300"
          placeholder="Form Name"
          width={"100%"}
          size={"lg"}
          readOnly={kyc}
          onChange={(e) => handleChangeName(e, tab.id)}
        />
        <Spacer />
      </Box>
    </>
  );
};

export default FormHeader;
